import { createFavouriteServiceImpl } from './favouriteService/inernal/FavouriteServiceImpl';
import { FavouriteService } from './FavouriteService';
import { SortBy, SortOrder, FavouriteCount } from './favouriteService/inernal/FavouriteResponse';
import { FavouriteRecord } from './favouriteService/model/FavouriteRecord';

const version = '__buildVersion__';

export {
  createFavouriteServiceImpl as createFavouriteService,
  FavouriteService,
  version,
  SortBy,
  SortOrder,
  FavouriteCount,
  FavouriteRecord,
};
